
export const formatIppn = (ippn) => {
    if (ippn.length === 13) {
        return ippn ? ippn.toString().replace(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{1}).*/, '$1.$2.$3.$4-$5') : ''
      } else if (ippn.length === 14) {
        return ippn ? ippn.toString().replace(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{1})(\d{1}).*/, '$1.$2.$3.$4-$5#$6') : ''
      } else {
        return ippn
    }
}

export const formatIppnFull = (ippn) => {
  if (ippn) {
    ippn = ippn.replace('A', '#')
    ippn = ippn.toString().replace(/^(\d{3})(\d{3})(\d{3})(\d{3})(\d{1})(.)(\d{3}).*/, '$1.$2.$3.$4-$5$6$7');
    if(ippn === 'Luva')
      return ippn
    if(ippn.slice(ippn.length-4) === '#000'){
      ippn = ippn.slice(0,ippn.length-4);
    }else{
      ippn = `${ippn.slice(0,ippn.length-3)}${Number(ippn.slice(ippn.length-3))}`;
    }
  }
  return ippn
}


export const formatNm = (nm) => {
  return nm ? nm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : ""
}

